export interface Device_Interface {
  id:number,
  title:String,
  observation:number,

  quantity_id: number,
  quantity:'',
  quantity_sub:'',
  persianDate:String,
  username:String,
  ip:String,
  del:boolean
  DeletingProccess:boolean
}

export function Empty_Device_Interface():Device_Interface{
  return{
    id:0,
    title: '',
    observation:0,

    quantity_id:0,
    quantity_sub:'',
    quantity:'',
    persianDate:'',
    username:'',
    ip:'',
    del:false,
    DeletingProccess:false,
  }
}

